module.exports = __webpack_public_path__ + "img/no-content.2ea396ed.png";